const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/home').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

const AnagraficheClienti = () => import('~/pages/anagrafiche/clienti').then(m => m.default || m)
const AnagraficheVettori = () => import('~/pages/anagrafiche/vettori').then(m => m.default || m)
const AnagraficheArticoli = () => import('~/pages/anagrafiche/articoli').then(m => m.default || m)

const AnagraficheImpianti = () => import('~/pages/anagrafiche/impianti').then(m => m.default || m)
const AnagraficheUbicazioni = () => import('~/pages/anagrafiche/ubicazioni').then(m => m.default || m)
const AnagraficheUtenti = () => import('~/pages/anagrafiche/utenti').then(m => m.default || m)
const AnagraficheTipologiaDocumenti = () => import('~/pages/anagrafiche/tipologia_documenti').then(m => m.default || m)
const AnagraficheTipologiaPicking = () => import('~/pages/anagrafiche/tipologia_picking').then(m => m.default || m)
const AnagraficheTipologiaStock = () => import('~/pages/anagrafiche/tipologia_stock').then(m => m.default || m)
const GestioneMagazzino = () => import('~/pages/gestione/magazzino').then(m => m.default || m)
const GestioneMagazzinoIngressi = () => import('~/pages/gestione/magazzino_ingressi').then(m => m.default || m)
const GestioneMagazzinoUscite = () => import('~/pages/gestione/magazzino_uscite').then(m => m.default || m)
const GestioneSpedizioni = () => import('~/pages/gestione/spedizioni').then(m => m.default || m)
const GestioneSpedizioniInAttesa = () => import('~/pages/gestione/spedizioni_in_attesa').then(m => m.default || m)
const ArchivioSpedizioni = () => import('~/pages/archivio/spedizioni_archivio').then(m => m.default || m)
const ArchivioSpedizioniEdit = () => import('~/pages/archivio/spedizioni_archivio_modifica').then(m => m.default || m)
const GestioneAttesaEdi = () => import('~/pages/gestione/spedizioni_da_confermare_edi').then(m => m.default || m)

const StatisticheEntrate = () => import('~/pages/statistiche/entrate').then(m => m.default || m)
const StatisticheUscite = () => import('~/pages/statistiche/uscite').then(m => m.default || m)

export default [
  {path: '/', name: 'welcome', component: Welcome},

  {path: '/login', name: 'login', component: Login},
  {path: '/register', name: 'register', component: Register},
  {path: '/password/reset', name: 'password.request', component: PasswordEmail},
  {path: '/password/reset/:token', name: 'password.reset', component: PasswordReset},

  {path: '/home', name: 'home', component: Home},
  {
    path: '/settings',
    component: Settings,
    children: [
      {path: '', redirect: {name: 'settings.profile'}},
      {path: 'profile', name: 'settings.profile', component: SettingsProfile},
      {path: 'password', name: 'settings.password', component: SettingsPassword}
    ]
  },
  {path: '/anagrafiche/clienti', name: 'anagrafiche.clienti', component: AnagraficheClienti},
  {path: '/anagrafiche/vettori', name: 'anagrafiche.vettori', component: AnagraficheVettori},
  {path: '/anagrafiche/articoli', name: 'anagrafiche.articoli', component: AnagraficheArticoli},

  {path: '/anagrafiche/impianti', name: 'anagrafiche.impianti', component: AnagraficheImpianti},
  {path: '/anagrafiche/ubicazioni', name: 'anagrafiche.ubicazioni', component: AnagraficheUbicazioni},
  {path: '/anagrafiche/utenti', name: 'anagrafiche.utenti', component: AnagraficheUtenti},
  {path: '/anagrafiche/tipologia_documenti', name: 'anagrafiche.tipologia_documenti', component: AnagraficheTipologiaDocumenti},
  {path: '/anagrafiche/tipologia_picking', name: 'anagrafiche.tipologia_picking', component: AnagraficheTipologiaPicking},
  {path: '/anagrafiche/tipologia_stock', name: 'anagrafiche.tipologia_stock', component: AnagraficheTipologiaStock},

  {path: '/gestione/magazzino', name: 'gestione.magazzino', component: GestioneMagazzino},
  {path: '/gestione/magazzino_ingressi', name: 'gestione.magazzino_ingressi', component: GestioneMagazzinoIngressi},
  {path: '/gestione/magazzino_uscite', name: 'gestione.magazzino_uscite', component: GestioneMagazzinoUscite},
  {path: '/gestione/spedizioni/nuova_spedizione', name: 'gestione.spedizioni', component: GestioneSpedizioni},
  {path: '/gestione/spedizioni/attesa', name: 'gestione.spedizioni_in_attesa', component: GestioneSpedizioniInAttesa},
  {path: '/gestione/spedizioni/archivio', name: 'gestione.spedizioni_archivio', component: ArchivioSpedizioni},
  {path: '/gestione/spedizioni/modifica', name: 'gestione.spedizioni_archivio_modifica', component: ArchivioSpedizioniEdit},
  {path: '/gestione/spedizioni/trasmissioni', name: 'gestione.conferma_trasmissione_edi', component: GestioneAttesaEdi},

  {path: '/statistiche/entrate', name: 'statistiche.entrate', component: StatisticheEntrate},
  {path: '/statistiche/uscite', name: 'statistiche.uscite', component: StatisticheUscite},

  {path: '*', component: NotFound}

]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js